// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"382":"79c97414","406":"1e32ffbc","626":"6d5e45e1"}[chunkId] + ".chunk.css";
};